/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

export const AUTOCOMPLETE_RESULT_CLICK = 'AUTOCOMPLETE_RESULT_CLICK'
export const SIGNUP_TENANT_TYPE = 'tenant'
